import { atom } from 'nanostores';

export type AuthOverlayType = 'login' | 'signup' | 'hidden';

export type AuthStore = {
  isSignedIn: boolean;
  overlay: AuthOverlayType;
};

export const $auth = atom<AuthStore>({ isSignedIn: false, overlay: 'hidden' });

export function openLogin() {
  $auth.set({ ...$auth.get(), overlay: 'login' });
}

export function openSignup() {
  $auth.set({ ...$auth.get(), overlay: 'signup' });
}

export function closeOverlay() {
  $auth.set({ ...$auth.get(), overlay: 'hidden' });
}

export function setOverlay(overlay: AuthOverlayType) {
  $auth.set({ ...$auth.get(), overlay });
}

export function setSignedIn() {
  $auth.set({ ...$auth.get(), isSignedIn: true });
}

export function setSignedOut() {
  $auth.set({ ...$auth.get(), isSignedIn: false });
}
